import { attr, belongsTo } from '@warp-drive/legacy/model';
import DigitalAsset from './digital-asset.ts';
import type ObservableDocument from './observable-document.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class ObservableAssetModel extends DigitalAsset {
  /*************************
   **  Attributes         **
   *************************/
  @attr declare description: string;
  @attr declare contentType: 'application/pdf' | 'application/txt';
  @attr declare classification: string;
  @attr declare externalUrl: string;

  /*************************
   **  Relationships      **
   *************************/
  @belongsTo('observable-document', { async: false, inverse: 'observableAsset' })
  declare observableDocument: ObservableDocument;

  [Type] = 'observable-asset' as const;
}
